/**
 * 带超时和网络检测的fetch请求
 * @param {string} url - 请求地址
 * @param {object} options - 请求配置
 * @param {object} vconfig - 额外配置项
 * @returns {Promise}
 */
async function fetchRequest(url, options = {}, vconfig) {
  // 1. 网络状态检测
  if (!navigator.onLine) {
    throw new Error('OFFLINE');
  }
  if(!vconfig){
    vconfig = {
      timeout: 20000,
    }
  }else if(!vconfig.timeout){
    vconfig.timeout = 20000;
  }
  // 2. 创建AbortController控制中止
  if(!vconfig.controller){
    vconfig.controller = new AbortController();
  }
  let timeoutId = setTimeout(() =>{
    timeoutId = -1
    vconfig.controller.abort()
  }, vconfig.timeout);

  try {
    if(!options.signal){
      options.signal = vconfig.controller.signal
    }
    // 3. 发起请求
    const response = await fetch(url, {
      ...options
    });

    clearTimeout(timeoutId);
    timeoutId = -1
    return response;

  } catch (error) {
    console.log(error)
    clearTimeout(timeoutId);

    // 5. 错误分类处理
    if (error.name === 'AbortError' && timeoutId !== -1) {
      throw new Error(error);
    }else if(error.name === 'AbortError'){
      throw new Error(`TIMEOUT`);
    }
    if (!navigator.onLine) {
      throw new Error('OFFLINE');
    }
    throw error;
  }
}
export default fetchRequest
